import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { PersonalizedTextBlock } from 'api/landingPageTheme'
import { buildTranslate } from 'locales'
import React, { useMemo } from 'react'
import Markdown from 'react-markdown'
import { useSelector } from 'react-redux'
import { selectExperience } from 'selectors/pointsExperience'

const t = buildTranslate(
  'cms.content.app_home_page.content.edit_block.content.personalized_text'
)

type Props = {
  contentBlock: PersonalizedTextBlock
  className?: string
}

const Preview = ({ contentBlock, className }: Props) => {
  const { settings } = contentBlock
  const { text = '', placeholder_values, fallback_behavior } = settings
  const pointsExperience = useSelector(selectExperience)
  const pointsCurrency = pointsExperience?.currency_name_plural
  const { first_name, last_name } = placeholder_values ?? {}

  const personalizedText = useMemo(
    () =>
      text
        .replaceAll('{{first_name}}', 'John')
        .replaceAll('{{last_name}}', 'Doe')
        .replaceAll('{{points_balance}}', '0')
        .replaceAll('{{points_currency}}', pointsCurrency ?? 'points'),
    [text, pointsCurrency]
  )

  const isMissingDefaultValues = useMemo(() => {
    if (fallback_behavior !== 'show_placeholders') return false

    const replacementText = text
      .replaceAll('{{first_name}}', first_name || 'INVALID')
      .replaceAll('{{last_name}}', last_name || 'INVALID')

    return replacementText.includes('INVALID')
  }, [fallback_behavior, first_name, last_name, text])

  return (
    <div className={className}>
      <div className={'p-m border rounded'}>
        <Markdown>{personalizedText}</Markdown>
      </div>
      <Switch condition={text.includes('{{')}>
        <Switch
          condition={
            fallback_behavior === 'show_placeholders' && isMissingDefaultValues
          }
        >
          <Text.BodyText3 className={'text-danger'}>
            {t('default_value_missing.show_placeholders')}
          </Text.BodyText3>
        </Switch>
        <Switch condition={fallback_behavior === 'hide'}>
          <Text.BodyText3>{t('default_value_missing.hide')}</Text.BodyText3>
        </Switch>
      </Switch>
    </div>
  )
}

export default Preview
